// Sets Hudl's ad targeting keys on anything with setTargeting(key, value): a GPT slot,
// or googletag.pubads() for page-level keys that also reach Freestar's own slots.
// Skips nonPersonalizedAds (callers handle it with setPrivacySettings), splits
// adContext 'k=v&k2=v2' into separate keys, and skips null or undefined values.
export default function applyTargeting(target, targetingData) {
  if (!targetingData || !target || typeof target.setTargeting !== 'function') return;

  Object.keys(targetingData).forEach(key => {
    if (key === 'nonPersonalizedAds') {
      return;
    }

    if (key === 'adContext' && targetingData[key]) {
      targetingData[key].split('&').forEach(pair => {
        const [ctxKey, ctxValue] = pair.split('=');
        if (ctxKey && ctxValue) {
          target.setTargeting(ctxKey, ctxValue);
        }
      });
    } else if (targetingData[key] !== null && targetingData[key] !== undefined) {
      target.setTargeting(key, targetingData[key]);
    }
  });
}
